import { Knqd } from '@martincolley/knqd-sdk'

let tracker = null

/**
 * Initialize the knqd.to tracker
 * @param {string} apiKey - Your knqd.to API key
 */
export const initKnqdTracker = (apiKey) => {
	if (!apiKey) {
		console.warn('[knqd.to] ❌ API key not provided. Tracking disabled.')
		return
	}

	tracker = new Knqd({
		apiKey
		// Optional: configure endpoint if needed
		// endpoint: 'https://ingest.knqd.to'
	})
}

/**
 * Track a DataService operation with schema-based mapping
 * Schema: firestore-writes
 * Required: collection, requestType, status
 * Optional: userId, errorMessage, responseTime, documentCount
 *
 * @param {string} operation - Operation type (read, write, batch, etc.)
 * @param {Object} metadata - Additional metadata about the operation
 */
export const trackDataOperation = async (operation, metadata = {}) => {
	if (!tracker) {
		console.warn(
			'[knqd.to] ⚠️ Tracker not initialized, skipping event:',
			`dataservice_${operation}`
		)
		return
	}

	const eventName = `dataservice_${operation}`

	try {
		// ONLY include properties defined in the firestore-writes schema
		const properties = {
			_schema: 'firestore-writes', // Required: schema identifier

			// Required fields (blob8, blob16, blob17)
			collection: metadata.path || 'unknown',
			requestType: operation,
			status: metadata.error ? 'error' : 'success',

			// Optional fields (only include if defined in schema)
			userId: tracker.config?.userId || 'anonymous', // blob5
			errorMessage: metadata.error || '', // blob18
			responseTime: metadata.duration || 0, // double6
			documentCount: metadata.documentCount || metadata.fieldCount || metadata.count || 0 // double2
		}

		// DO NOT include: hasFilters, hasPagination, merge, operation, paths, etc.
		// Those are NOT in the schema and will be ignored by the worker

		// SDK signature: track(eventName, properties, options)
		await tracker.track(eventName, properties, { immediate: false })
	} catch (error) {
		// Don't break the app if tracking fails
		console.error('[knqd.to] ❌ Tracking error:', error)
	}
}

/**
 * Get the tracker instance (for advanced usage)
 */
export const getTracker = () => tracker
